import React from 'react';
import { Row, Col, Button } from 'react-bootstrap'
import { useAppSelector, useAppDispatch } from '../../hooks'
import {TOKENS, SOL} from '../../constants/constants'
import { setBetMultiplier, setBetAmount } from "../../redux/reducers/storageSlice"
const Multipliers: React.FC = () => {
    
    const dispatch = useAppDispatch();
    const mode = useAppSelector(state => state.storage.mode)
    const token = useAppSelector(state => state.storage.token)
    const betMultiplier = useAppSelector(state => state.storage.betMultiplier)
    const betAmount = useAppSelector(state => state.storage.betAmount)
    let largestMultiplierComp = null;
    let mainMultiplierComps = null;
    let selector = SOL
    
    const selectMultiplier = (multiplier: any) => {
        dispatch(setBetMultiplier(multiplier))
        let foundMultiplier = selector.find(element => element.value ==multiplier)
        // console.log(betAmount)
        // console.log(foundMultiplier.amounts)
        // console.log(foundMultiplier.amounts.includes(betAmount))
        let newAmount = foundMultiplier.amounts[foundMultiplier.amounts.length-1]
        if (!foundMultiplier.amounts.includes(betAmount)) dispatch(setBetAmount(newAmount))
    }
            
    if (mode =="Token") {
        selector = TOKENS[token]["betConstraints"];
    }
    let measurement = selector.length - 1
    let largestMultiplier = selector[measurement]
    if (selector.length > 2){
        largestMultiplierComp = (
            <Row style={{paddingBottom: 20}}>
                <Col style={{padding: 1}}>
                    <Button variant="light" style={{width: '33.333%', border: "2px solid black"}} active={betMultiplier ==largestMultiplier.value} onClick={() => {selectMultiplier(largestMultiplier.value)}}>
                        <div>
                            <h4 style={{marginBottom: 0, color: "black"}}>{largestMultiplier.value}x</h4>
                            <p style={{marginBottom: 0, fontWeight: 500, color: "black"}}>{largestMultiplier.percentage}%</p>
                        </div>
                    </Button>
            </Col>
            </Row>
        )
    } else {
        measurement = selector.length
    }

    mainMultiplierComps = selector.map((selection, index) => {
        
        if (index < (measurement)){
            return (
                <Col style={{padding: 1}}>
                    <Button variant="light" style={{width: '100%'}} active={betMultiplier ==selection.value} onClick={() => {selectMultiplier(selection.value)}}>
                        <div>
                            <h4 style={{marginBottom: 0,color: "black"}}>{selection.value}x</h4>
                            <p style={{marginBottom: 0, fontWeight: 500,color: "black"}}>{selection.percentage}%</p>
                        </div>
                    </Button>
                </Col>
            )
        } else {
            return null
        }
    })     
        

    return (
        <div>
            <Row style={{paddingBottom: 20, justifyContent: 'center' }}>
                <h3 style={{color: "black", border: "2px solid black", background: "rgba(255,255,255,0.6)", width: "auto"}}>MULTIPLIER</h3>
            </Row>
            
                {largestMultiplierComp}
                         
            <Row style={{display: "flex", justifyContent: "center"}}>
                {mainMultiplierComps}
            </Row>   
        </div>
    );
}

export default Multipliers;